// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Xtay","selected":"Chip_selected__1-DyZ"};